export const PROMO_GROUP_MOBILE_BREAKPOINT = 640
